import React, { useRef } from 'react';
import Layout from '@/presentation/layout/Layout';
import { useAppSelector } from '@/hooks/customHooks';
import ContactUsSub from '@/components/help-desk/ContactUsSub';

const ContactUs: React.FC = () => {
  const authState = useAppSelector((state) => state.auth);
  const isSignedIn = authState.isSignedIn;
  const helpDeskRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={helpDeskRef}>
      {isSignedIn && (
        <Layout displayTopBar={false} hasNoWrapper={true}>
          <ContactUsSub />
        </Layout>
      )}
      {!isSignedIn && <ContactUsSub />}
    </div>
  );
};

export default ContactUs;
